/**
 * Derive a stable storage key from a resource URL.
 *
 * Shared by the download manager (write) and the service worker (read).
 * A mismatch between writer and reader is a silent cache miss, so this is
 * the ONLY place a key may be computed. Rules:
 *   - drop scheme + host (origin-relative)
 *   - drop the query string (signed-URL params expire and must not vary the key)
 *   - decode percent-encoding
 *   - collapse duplicate slashes, ensure a single leading slash
 */
export function resourceKey(url: string): string {
  const parsed = new URL(url, 'https://_dummy_');
  let path = decodeURIComponent(parsed.pathname);
  path = path.replace(/\/{2,}/g, '/');
  if (!path.startsWith('/')) path = `/${path}`;
  return path;
}
